import type { Field } from "@fobu/schema";

/** WCAG 2.2 / 1.3.5: Zweck von Eingaben aus dem Feld-Key ableiten, falls nicht explizit gesetzt. */
const BY_KEY: Array<[RegExp, string]> = [
  [/^(vorname|first_?name|given_?name)$/, "given-name"],
  [/^(nachname|last_?name|family_?name|surname)$/, "family-name"],
  [/^(name|full_?name|voller_?name)$/, "name"],
  [/^(e_?mail|mail)$/, "email"],
  [/^(telefon|tel|phone|mobil|handy)$/, "tel"],
  [/^(plz|postleitzahl|zip|postal_?code)$/, "postal-code"],
  [/^(ort|stadt|wohnort|city)$/, "address-level2"],
  [/^(strasse|straße|street|adresse|address)$/, "street-address"],
  [/^(land|country)$/, "country-name"],
  [/^(firma|unternehmen|organisation|organization|company)$/, "organization"],
  [/^(geburtsdatum|birthday|bday|geburtstag)$/, "bday"],
  [/^(website|webseite|url|homepage)$/, "url"],
];

export function autocompleteFor(field: Field): string | undefined {
  if ("autocomplete" in field && field.autocomplete) return field.autocomplete;
  for (const [re, token] of BY_KEY) if (re.test(field.key)) return token;
  if (field.type === "email") return "email";
  if (field.type === "phone") return "tel";
  if (field.type === "url") return "url";
  return undefined;
}
